import { Link } from 'react-router-dom';
import { Award, Facebook, Instagram, Linkedin } from 'lucide-react';
import whatsappIcon from '../images/icons/icon-whatsapp.webp';

const Footer = () => {
  return (
    <footer className="w-full bg-offwhite border-t border-charcoal/10 py-12">
      <div className="px-6 lg:px-[7vw]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <img src="/logo.webp" alt="Molomo NR" className="h-10 mb-4" />
            <p className="text-charcoal/80 text-sm mb-4">
              Industrial storage solutions for warehouses, retail, and manufacturing. B-BBEE Level 1 certified.
            </p>
            <a 
              href="/B-BBEEMolomoNR.pdf" 
              download 
              className="inline-flex items-center gap-2 bg-lime text-charcoal px-6 py-3 rounded-lg font-medium hover:bg-lime/90 transition-colors"
            >
              <Award className="w-4 h-4" />
              Download B-BBEE Certificate
            </a>
          </div>

          {/* Products */}
          <div>
            <h2 className="font-display font-bold text-charcoal mb-4 text-base">Products</h2>
            <ul className="space-y-2">
              <li><Link to="/products/racking" className="text-charcoal/80 hover:text-charcoal text-sm transition-colors">Pallet Racking</Link></li>
              <li><Link to="/products/shelving" className="text-charcoal/80 hover:text-charcoal text-sm transition-colors">Industrial Shelving</Link></li>
              <li><Link to="/products/mezzanine" className="text-charcoal/80 hover:text-charcoal text-sm transition-colors">Mezzanine Floors</Link></li>
              <li><Link to="/products/storage" className="text-charcoal/80 hover:text-charcoal text-sm transition-colors">Lockers & Storage</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h2 className="font-display font-bold text-charcoal mb-4 text-base">Company</h2>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-charcoal/80 hover:text-charcoal text-sm transition-colors">About Us</Link></li>
              <li><Link to="/capabilities" className="text-charcoal/80 hover:text-charcoal text-sm transition-colors">Our Capabilities</Link></li>
              <li><Link to="/projects" className="text-charcoal/80 hover:text-charcoal text-sm transition-colors">Our Projects</Link></li>
              <li><Link to="/contact" className="text-charcoal/80 hover:text-charcoal text-sm transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h2 className="font-display font-bold text-charcoal mb-4 text-base">Get in Touch</h2>
            <ul className="space-y-3 text-sm text-charcoal/80">
              <li><span className="font-medium text-charcoal">Phone:</span> +27 82 971 3299</li>
              <li><span className="font-medium text-charcoal">Email:</span> nhlapolindiwe4@gmail.com</li>
              <li><span className="font-medium text-charcoal">Address:</span> 7323 Zone 12 ext, Sebokeng 1983</li>
            </ul>

            {/* Social Links */}
            <div className="flex items-center gap-3 mt-4">
              <a href="https://api.whatsapp.com/send?phone=27829713299" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" className="w-10 h-10 rounded-lg bg-charcoal/5 flex items-center justify-center text-charcoal/60 hover:bg-lime hover:text-charcoal transition-colors">
                <img src={whatsappIcon} alt="WhatsApp" className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/molomonr" target="_blank" rel="noopener noreferrer" aria-label="Visit our Facebook page" className="w-10 h-10 rounded-lg bg-charcoal/5 flex items-center justify-center text-charcoal/60 hover:bg-lime hover:text-charcoal transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/molomonr" target="_blank" rel="noopener noreferrer" aria-label="Visit our Instagram page" className="w-10 h-10 rounded-lg bg-charcoal/5 flex items-center justify-center text-charcoal/60 hover:bg-lime hover:text-charcoal transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/molomonr" target="_blank" rel="noopener noreferrer" aria-label="Visit our LinkedIn page" className="w-10 h-10 rounded-lg bg-charcoal/5 flex items-center justify-center text-charcoal/60 hover:bg-lime hover:text-charcoal transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-charcoal/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-charcoal/70">
            © {new Date().getFullYear()} Molomo NR Trading and Projects (Pty) Ltd. All rights reserved.
          </p>
          <p className="text-xs text-charcoal/70">
            Created by <a href="mailto:bekithemba.mdluli.bm@gmail.com" className="hover:text-charcoal transition-colors">Themba</a> & <a href="mailto:viihunnid@icloud.com" className="hover:text-charcoal transition-colors">Isaac</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
